import script from "./AdminElderly.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminElderly.vue?vue&type=script&setup=true&lang=js"

import "./AdminElderly.vue?vue&type=style&index=0&id=79f1d37f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79f1d37f"]])

export default __exports__